<template>
  <div class="main-content">
    <div class="content">
      <p class="title">Lecle Reviews</p>
      <img src="lecle-image.png" alt="lecle" />
      <GGLoginButton />
      <em>© Copyright 2020, LECLE.</em>
    </div>
  </div>
</template>

<script>
import GGLoginButton from '@/components/GoogleLoginButton';

export default {
  name: 'LoginPage',
  data() {
    return {};
  },
  components: { GGLoginButton },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors.scss';
img {
  display: inline-block;
  width: 8rem;
  height: 8rem;
  animation: bounce 2s linear, spin 2s 2s linear infinite;
  margin-bottom: 4rem;
}

@keyframes spin {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

@keyframes bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(1.1, 0.9) translateY(0);
  }
  30% {
    transform: scale(0.9, 1.1) translateY(-20px);
  }
  50% {
    transform: scale(1, 1) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(-7px);
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}

.title {
  padding-bottom: 0.3rem;
  color: $darkBlue;
  border-bottom: 1px solid $darkBlue;
  margin-bottom: 4rem;
}

.content {
  background: white;
  padding: 4rem 8rem 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 0.5rem;
  box-shadow: 7px 7px 10px 0px rgba(0, 0, 0, 0.3);
}
.main-content {
  min-height: 100vh;
  background: $gray;

  display: flex;
  justify-content: center;
  align-items: center;
}

em {
  margin-top: 3rem;
  font-size: 1.2rem;
}
</style>
